<template>
	<Col>
		<Row class="flex-align-center flex-justify-space-between width-100">
			<Row class="flex-align-center">
				<AppIcon :name="iconName" :width="25" :height="25" />
				<h5 class="mx-2">{{ title }}</h5>
				<AppTooltip noArrow :text="tooltipText" position="top">
					<AppIcon class="pointer" name="installation-tab-info" width="12" height="12" />
				</AppTooltip>
			</Row>
			<AppSwitch class="swtch sml" v-model="isOnLocal" />
		</Row>
		<v-expand-transition>
			<h5 v-if="isOnLocal && explanationHtml" v-html="explanationHtml" class="explanation pt-0 pb-2 pr-3" />
		</v-expand-transition>
	</Col>
</template>
<script>
export default {
	name: 'PublishDropdownConfigurationItem',
	components: {},
	props: {
		title: { type: String },
		iconName: { type: String },
		tooltipText: { type: String },
		valueGetter: { type: Function },
		valueSetter: { type: Function },
		explanationHtml: { type: String },
	},
	computed: {
		isOnLocal: {
			get() {
				return this.valueGetter();
			},
			set(value) {
				return this.valueSetter(value);
			},
		},
	},
};
</script>
<style scoped lang="scss">
.explanation {
	font-weight: 300;
	color: #969596;
	padding-left: 34px;
}
</style>
